export enum APPS {
  ACCESS_MANAGER = 'Access Manager',
  MANAGED_FILE_TRANSFER = 'Managed File Transfer',
  ADS = 'ADS',
  CAIS_IQ = 'Cais IQ',
  CAIS_COMPASS = 'CAIS Compass',
  CONTAINER = 'Container',
  CUSTODIAN_MANAGER = 'Custodian Manager',
  DOCUMENT_LIBRARY = 'Document Library',
  DOCUMENT_TAGGING = 'Document Tagging',
  FUND_MANAGER = 'Fund Manager',
  FUNDS_PRE_TRADE = 'Funds Pre-Trade',
  FUNDS_PRODUCT_MASTER = 'Funds Product Master',
  FUNDS_TRADE = 'Funds Trade',
  HOME_OFFICE_INSIGHTS = 'Home Office Insights',
  HOMEPAGE = 'Homepage & Content',
  INVESTOR_PROFILE = 'Investor Profile',
  PRODUCT_MASTER = 'Product Master',
  STRUCTURED_PRODUCTS = 'Structured Products',
  SYSTEMS_MANAGER = 'Systems Manager',
  PRODUCT_PERMISSIONS = 'Product Permissions',
  MODEL_PORTFOLIO = 'Model Portfolio',
  DOWNSTREAM_DATA = 'Downstream Data',
  FUNDS_HOLDINGS = 'Funds Holdings',
  FUND_ADMIN_MANAGER = 'Fund Admin Manager',
  MARKET_DATA = 'Market Data',
}

export enum APP_IDS {
  ACCESS_MANAGER = 'access-manager',
  MANAGED_FILE_TRANSFER = 'managed-file-transfer',
  ADS = 'ads',
  CAIS_IQ = 'cais-iq',
  CUSTODIAN_MANAGER = 'custodian-manager',
  CAIS_COMPASS = 'cais-compass',
  DOCUMENT_LIBRARY = 'document-library',
  DOCUMENT_TAGGING = 'document-tagging',
  FUND_MANAGER = 'fund-manager',
  FUNDS_TRADE = 'funds-trade',
  FUNDS_PRE_TRADE = 'funds-pre-trade',
  FUNDS_PRODUCT_MASTER = 'funds-product-master',
  HOME_OFFICE_INSIGHTS = 'home-office-insights',
  HOMEPAGE = 'homepage',
  INVESTOR_PROFILE = 'investor-profile',
  PRODUCT_MASTER = 'product-master',
  STRUCTURED_PRODUCTS = 'structured-investments',
  SYSTEMS_MANAGER = 'systems-manager',
  MODEL_PORTFOLIO = 'model-portfolios',
  DOWNSTREAM_DATA = 'downstream-data',
  FUNDS_HOLDINGS = 'funds-holdings',
  FUND_ADMIN_MANAGER = 'fundadmin-manager',
  MARKET_DATA = 'market-data',
}

export const APP_PATHS = [
  'access-manager',
  'managed-file-transfer',
  'ads',
  'custodian-manager',
  'cais-compass',
  'container',
  'document-library',
  'document-tagging',
  'fund-manager',
  'funds-trade',
  'funds-pre-trade',
  'funds-product-master',
  'home-office-insights',
  'homepage',
  'investor-profile',
  'product-master',
  'structured-products',
  'structured-investments',
  'systems-manager',
  'model-portfolios',
  'downstream-data',
  'funds-holdings',
  'fundadmin-manager',
  'market-data',
] as const
